import { useLayoutEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import RevealLines from '@/components/base/RevealLines';
import { phases } from '@/mocks/site';

gsap.registerPlugin(ScrollTrigger);

export default function Approach() {
  const root = useRef<HTMLElement>(null);

  useLayoutEffect(() => {
    const el = root.current;
    if (!el) return undefined;
    const mm = gsap.matchMedia();
    mm.add('(prefers-reduced-motion: no-preference)', () => {
      const list = el.querySelector('.ff-steps');
      list?.classList.add('is-armed');
      const items = gsap.utils.toArray<HTMLElement>('.ff-step', el);
      const triggers = items.map((item) => ScrollTrigger.create({
        trigger: item,
        start: 'top 65%',
        end: 'bottom 40%',
        invalidateOnRefresh: true,
        toggleClass: { targets: item, className: 'is-active' },
      }));
      const wedge = gsap.fromTo('.ff-wedge-approach', { xPercent: 30 }, {
        xPercent: 0, ease: 'none', scrollTrigger: { trigger: el, start: 'top bottom', end: 'top top', scrub: true, invalidateOnRefresh: true },
      });
      return () => {
        triggers.forEach((t) => t.kill());
        wedge.scrollTrigger?.kill();
        wedge.kill();
        list?.classList.remove('is-armed');
        items.forEach((i) => i.classList.remove('is-active'));
      };
    });
    return () => mm.revert();
  }, []);

  return (
    <section id="approach" ref={root} aria-label="Our approach" className="relative overflow-hidden bg-background-50">
      <div aria-hidden className="ff-wedge-approach absolute inset-0 bg-primary-500" />

      <div className="relative grid grid-cols-1 lg:grid-cols-12 gap-12 px-4 md:px-6 py-20 md:py-24">
        <div className="lg:col-span-6">
          <p className="font-label text-[11px] uppercase tracking-[0.18em] text-secondary-600" data-reveal="up">Our approach / 04</p>
          <RevealLines lines={['From the first', 'spark to the', 'final moment.']} className="mt-5 font-extrabold tracking-[-0.055em] leading-[0.9] text-[clamp(2.4rem,5.6vw,6rem)]" />

          <ol className="ff-steps mt-10 md:mt-14 border-t border-foreground-950/15">
            {phases.map((p, i) => (
              <li key={p.word} className="ff-step grid grid-cols-[3.5rem_1fr] md:grid-cols-[5rem_1fr] gap-4 border-b border-foreground-950/15 py-5 md:py-6">
                <span className="ff-step-no font-label text-xs text-secondary-600 pt-2">0{i + 1}</span>
                <div>
                  <p className="text-3xl md:text-5xl font-extrabold tracking-[-0.045em] leading-none">{p.word}</p>
                  <p className="mt-3 text-sm md:text-base text-foreground-700 max-w-[380px]">{p.copy}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>

      </div>
    </section>
  );
}